import { useTranslation } from "react-i18next";

import { QuestionOption } from "@/components/survey/Question";

export type PhqOption =
  | "notAtAll"
  | "severalDays"
  | "moreThanHalfTheDays"
  | "nearlyEveryDay";

export const usePhq = () => {
  const { t } = useTranslation();

  const phqOptions: (QuestionOption & {
    id: PhqOption;
  })[] = [
    {
      id: "notAtAll",
      text: t("survey.questions.phq.options.notAtAll"),
    },
    {
      id: "severalDays",
      text: t("survey.questions.phq.options.severalDays"),
    },
    {
      id: "moreThanHalfTheDays",
      text: t("survey.questions.phq.options.moreThanHalfTheDays"),
    },
    {
      id: "nearlyEveryDay",
      text: t("survey.questions.phq.options.nearlyEveryDay"),
    },
  ];

  return { phqOptions };
};
